import { ENTWURF, FASSUNG } from "../seiten/rechtliches/texte";
import type { Ich } from "./typen";

/** W17b: „Jetzt nicht“ gilt nur, bis die Seite neu geladen oder neu angemeldet wird; bewusst
 *  nicht im Speicher des Browsers (nichts auf dem Geraet ablegen, § 25 TDDDG). */
let spaeter = false;

export function spaeterFragen(): void {
  spaeter = true;
}

/** Bei einer neuen Anmeldung wird wieder gefragt. */
export function fassungZuruecksetzen(): void {
  spaeter = false;
}

/** Hat das Konto einer aelteren Fassung der Rechtstexte zugestimmt als der, die die App zeigt?
 *  Fassungen sind Tage als `JJJJ-MM-TT` und sortieren als Text. Ein aelterer Server, der das Feld
 *  nicht schickt, loest keine Frage aus. */
export function fassungOffen(ich: Ich): boolean {
  // Solange die Texte „Entwurf“ sagen, bittet die App niemanden, ihnen zuzustimmen (Verifier W17b
  // F5): sonst muessten alle nach der Fertigstellung ein zweites Mal. Die Browser-Tests schalten
  // die Frage ausdruecklich ein.
  if (ENTWURF && !(globalThis as { papiergaistFassungFragen?: boolean }).papiergaistFassungFragen) return false;
  if (spaeter || ich.einwilligung_fassung === undefined) return false;
  return ich.einwilligung_fassung === null || ich.einwilligung_fassung < FASSUNG;
}
